<template>
  <navigation v-if="!embedded" />

  <main
    :class="[
      'wrapper',
      embedded ? 'wrapper-padding-top-0' : ''
    ]">
    <slot />

    <aside
      v-show="!embedded"
      class="qrcode-wrapper">
      <div class="qrcode">
        <img
          src="https://static.nuonuo.com.cn/zycmp/ichenuonuo-qrcode.png"
          alt="微信扫描二维码，关注爱车的诺诺">
      </div>
    </aside>
  </main>
</template>

<script setup>
import {storeToRefs} from 'pinia'
import Navigation from '@components/navigation'
import {useApplicationStore} from '@stores/application.store'

defineOptions({
  name: 'LayoutDefault',
})

// embedded
// - When inside a WeChat mini-program / Douyin micro-app webview or the
//   IBS iframe, the site's own top navigation must not render.
const {embedded} = storeToRefs(useApplicationStore())
</script>
